<script>
/**
 * Auth layout: panel de marca (rueda PHVA) + zona de formulario.
 * El contenido de cada página de acceso entra por el slot por defecto.
 * Estilos en src/assets/scss/sst/_auth.scss (spec 03, sección Acceso).
 */
export default {
  data() {
    return {};
  },
  mounted() {
    // Marca el body para anular estilos globales del shell (p. ej. padding inferior en móvil)
    document.body.classList.add("auth-body");
  },
  beforeDestroy() {
    document.body.classList.remove("auth-body");
  },
};
</script>

<template>
  <div class="auth-page">
    <aside class="auth-panel" aria-label="e-Misión SG-SST">
      <router-link to="/" class="auth-panel__logo">
        <img
          src="@/assets/images/logoemi.png"
          alt="e-Misión, Seguridad y Salud en el Trabajo"
          width="2134"
          height="500"
        />
      </router-link>

      <div class="auth-panel__body">
        <svg
          class="auth-wheel"
          viewBox="-174 -174 348 348"
          role="img"
          aria-labelledby="auth-wheel-title"
        >
          <title id="auth-wheel-title">
            Ciclo PHVA: Planear, Hacer, Verificar, Actuar
          </title>
          <g class="auth-wheel__sectors">
            <path d="M-171.7 -10.5A172 172 0 0 1 -10.5 -171.7L-5.9 -95.8A96 96 0 0 0 -95.8 -5.9Z" />
            <path d="M10.5 -171.7A172 172 0 0 1 171.7 -10.5L95.8 -5.9A96 96 0 0 0 5.9 -95.8Z" />
            <path d="M171.7 10.5A172 172 0 0 1 10.5 171.7L5.9 95.8A96 96 0 0 0 95.8 5.9Z" />
            <path d="M-10.5 171.7A172 172 0 0 1 -171.7 10.5L-95.8 5.9A96 96 0 0 0 -5.9 95.8Z" />
          </g>
          <g class="auth-wheel__flow">
            <path d="M-3 -5L3 0L-3 5" transform="translate(0 -134)" />
            <path d="M-3 -5L3 0L-3 5" transform="translate(134 0) rotate(90)" />
            <path d="M-3 -5L3 0L-3 5" transform="translate(0 134) rotate(180)" />
            <path d="M-3 -5L3 0L-3 5" transform="translate(-134 0) rotate(270)" />
          </g>
          <g class="auth-wheel__labels" text-anchor="middle">
            <text x="-94.8" y="-94.8">Planear</text>
            <text x="94.8" y="-94.8">Hacer</text>
            <text x="94.8" y="94.8">Verificar</text>
            <text x="-94.8" y="94.8">Actuar</text>
          </g>
          <text class="auth-wheel__core" x="0" y="12" text-anchor="middle">
            PHVA
          </text>
        </svg>

        <p class="auth-panel__phrase">Tu SG-SST, del plan a la mejora continua.</p>

        <ul class="auth-panel__values">
          <li>
            <strong>Estándares mínimos</strong>
            Res. 0312 de 2019, ítem por ítem.
          </li>
          <li>
            <strong>Evidencias y firmas</strong>
            Cada ítem con su respaldo registrado.
          </li>
          <li>
            <strong>Indicadores y plan de trabajo</strong>
            Para cerrar brechas a tiempo.
          </li>
        </ul>
      </div>
    </aside>

    <div class="auth-side">
      <main id="main" class="auth-main">
        <div class="auth-form-wrap">
          <slot />
        </div>
      </main>

      <footer class="auth-footer">
        <span>{{ new Date().getFullYear() }} &copy; Emisión</span>
      </footer>
    </div>
  </div>
</template>
